import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const ProtectedRoute = ({ children }) => {
    const { user } = useAuth();
    const token = localStorage.getItem("token");

    if (!user && !token) {
        return <Navigate to="/login" />;
    }

    return children;
};

export default ProtectedRoute;
